import React, { useState } from 'react';
import Moment from "moment/moment";
import {connect} from "react-redux";
import {useForm} from "react-hook-form";
import {CardBody, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

// actions
import {setFilter} from "../../../redux/actions/generalActions/listActions";

// components
import SelectGeneric from "../../../components/select/selectGeneric";
import { ButtonClean, ButtonSearch} from "../../../components/buttons/buttonsActions";

// providers
import {udnProvider} from "../../../providers/udnProvider";
import {currencyProvider} from "../../../providers/currencyProvider";
import {paymentStatusProvider} from "../../../providers/xwitchLogProvider";
import {applicativeProvider} from "../../../providers/applicativeProvider";
import {paramSettingsProvider} from "../../../providers/paramSettingsProvider";
import {xwitchLogProvider} from "../../../providers/xwitchlog/xwitchlogProvider";
import {paymentMethodProvider} from "../../../providers/configuration/paymentMethodProvider";


function XwitchLogFilters(props) {
    const [paymentStatusId, setPaymentStatusId] = useState( null);
    const [transactionStatus, setTransactionStatus] = useState( null);
    const [applicative, setApplicative] = useState( null);
    const [os, setOS] = useState( null);
    const [currency, setCurrency] = useState( null);
    const [udn, setUdn] = useState( null);
    const [method, setMethod] = useState( null);
    const [resetValues, setResetValues] = useState(false);
    const [errorType, setErrorType] = useState(null)
    const [paymentMethod, setPaymentMethod] = useState(null)

    const cleanFields = () => {
        setPaymentStatusId(null);
        setApplicative(null);
        setOS(null);
        setCurrency(null);
        setTransactionStatus(null);
        setUdn(null);
        setMethod(null);
        setErrorType(null)
        setPaymentMethod(null)
        setResetValues(!resetValues);
        reset();
    }

    const {register, handleSubmit, reset} = useForm({
    });

    const onSubmit = async (data, _) => {
        const _dataFilter = {
            registerDate : '',
            xwitchLog : {
                ...data,
                paymentStatus : null,
                transactionStatus : null,
                salesId : '',
                applicative : null,
                os : null,
                currency : null,
            }
        };

        if(transactionStatus === 'ERROR' && errorType != null)
            _dataFilter.xwitchLog.errorType = errorType
        
        if (data.salesId !== '')
            _dataFilter.xwitchLog.salesId = '%' + data.salesId + '%';

        if (data.from !== '')
            _dataFilter.from = Moment(data.from).format('yyyy-MM-DD 00:00:00')

        if (data.to !== '')
            _dataFilter.to = Moment(data.to).format('yyyy-MM-DD 23:59:59')

        if (paymentStatusId !== undefined && paymentStatusId !== null && paymentStatusId !== '')
            _dataFilter.xwitchLog.paymentStatus = paymentStatusId;

        if (transactionStatus !== undefined && transactionStatus !== null && transactionStatus !== '')
            _dataFilter.xwitchLog.transactionStatus = transactionStatus;

        if ( applicative !== undefined && applicative !== null  )
            _dataFilter.xwitchLog.applicative = { id: applicative };

        if ( os !== undefined && os !== null )
            _dataFilter.xwitchLog.os = { id: os };

        if ( udn !== undefined && udn !== null )
            _dataFilter.udn = { id: udn };

        if ( method !== undefined && method !== null )
            _dataFilter.xwitchLog.xwitchMethod = method;

        if ( currency !== undefined && currency !== null  && currency !== '' )
            _dataFilter.xwitchLog.currency = currency;

        if ( paymentMethod !== undefined && paymentMethod !== null  && paymentMethod !== '' )
            _dataFilter.xwitchLog.paymentMethod = {id: paymentMethod};

        props.setFilter(_dataFilter);
    };

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody className="">
                <Row>
                    <Col md="2">
                        <FormGroup>
                            <Label>Id de venta (salesId) </Label>
                            <Input type="text" name="salesId"
                                   placeholder="Busqueda por Id"
                                   innerRef={register}/>
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>Aplicación</Label>
                            <SelectGeneric
                                initialValue={ applicative }
                                setExternalValue = { value => setApplicative( value ) }
                                isDisabled = { false }
                                resetValue={ resetValues }
                                provider = { applicativeProvider }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <SelectGeneric
                                title={ 'Unidad de negocio' }
                                initialValue={ udn }
                                setExternalValue={ setUdn }
                                provider={ udnProvider }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <SelectGeneric
                                title={ 'Moneda' }
                                initialValue={ currency }
                                setExternalValue={ setCurrency }
                                provider={ currencyProvider }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <SelectGeneric
                                title={ 'Sistema operativo' }
                                initialValue={ os }
                                setExternalValue={ setOS }
                                provider={ paramSettingsProvider }
                                customFilter={{item:{ps_key: 'xkynet_config_os_options'}} }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>Estatus del pago</Label>
                            <SelectGeneric
                                initialValue={ paymentStatusId }
                                setExternalValue = { value => setPaymentStatusId( value ) }
                                isDisabled = { false }
                                resetValue={ resetValues }
                                provider = { paymentStatusProvider }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{'Estatus transacción'}</Label>
                            <br/>
                            <SelectGeneric
                                initialValue={transactionStatus}
                                setExternalValue={ setTransactionStatus }
                                customFilter={{ item : {ps_key: 'xwitch_log_transaction_status'}} }
                                provider={paramSettingsProvider}
                            />
                        </FormGroup>
                    </Col>
                    {
                        transactionStatus === 'ERROR' && <Col md="2">
                            <FormGroup>
                                <Label>Error identificado</Label>
                                <br/>
                                <SelectGeneric
                                    initialValue={errorType}
                                    setExternalValue={ setErrorType }
                                    provider={xwitchLogProvider}
                                />
                            </FormGroup>
                        </Col>
                    }
                    <Col md="2">
                        <FormGroup>
                            <Label>{'Método de Xapi'}</Label>
                            <br/>
                            <SelectGeneric
                                initialValue={method}
                                setExternalValue={ setMethod }
                                customFilter={{ item : {ps_key: 'xwitch_log_methods'}} }
                                provider={paramSettingsProvider}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{'Método de Pago'}</Label>
                            <br/>
                            <SelectGeneric
                                initialValue={paymentMethod}
                                setExternalValue={ setPaymentMethod }
                                provider={paymentMethodProvider}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="1">
                        <FormGroup>
                            <Label>{'No. Tarjetas'}</Label>
                            <Input type="number"
                                   name="cardCount"
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="1">
                        <FormGroup>
                            <Label>{'PromoCode'}</Label>
                            <Input type="text"
                                   name="promoCode"
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>Desde</Label>
                            <Input type="date" name="from"
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>Hasta</Label>
                            <Input type="date" name="to"
                                   innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md="12" className="d-flex justify-content-center">
                        <div className="float-right">
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    listProps: state.listProps,
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(XwitchLogFilters)
